// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3PcMc","rootCenter":"LoadMoreObserver_rootCenter__1zEeo","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__22xYh"};